import classNames from 'classnames/bind';
import { getDurationKr } from 'common/utils';
import Slider, { Handle } from 'rc-slider';
import { useState } from 'react';
import { IMarks } from '../types';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  label: string | React.ReactNode;
  clickCode: string;
  min: number;
  max: number;
  current: number;
  setValue: Function;
}

const style = {
  mark_min: {
    top: '3px',
    marginTop: '4px',
    fontSize: '13px',
    color: '#8f8f8f',
    wordBreak: 'keep-all',
    transform: 'none',
    msTransform: 'none',
  },
  mark_max: {
    top: '3px',
    left: 'auto',
    right: '0',
    marginTop: '4px',
    fontSize: '13px',
    color: '#8f8f8f',
    wordBreak: 'keep-all',
    transform: 'none',
    msTransform: 'none',
  },
  label: {
    position: 'absolute' as const,
    bottom: '100%',
    left: '0',
    right: '0',
    margin: '0 0 20px',
    fontSize: '14px',
    fontWeight: 600,
  },
  label_name: {
    display: 'inline-block',
    marginRight: '4px',
    color: '#666666',
  },
  label_value: {
    color: '#5398f5',
  },
  slider: {
    width: 'auto',
    margin: '36px 5px 19px',
    height: '21px',
    padding: '10px 0 9px',
  },
  track: {
    height: '2px',
    backgroundColor: '#5398f5',
  },
  rail: {
    height: '2px',
    backgroundColor: '#d6dde2',
  },
  handle: {
    marginTop: '-10px',
    width: '21px',
    height: '21px',
    border: 'none',
    borderRadius: '15px',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.15)',
    backgroundColor: '#ffffff',
  },
  dot: {
    display: 'none',
  },
};

function DurationFilter(props: IProps) {
  const { label, clickCode, min, max, current, setValue } = props;
  const [position, setPosition] = useState(current);
  const marks: IMarks = {
    [min]: {
      style: style.mark_min,
      label: getDurationKr(min),
    },
    [max]: {
      style: style.mark_max,
      label: getDurationKr(max),
    },
  };

  const handle = (childProps: any) => (
    <>
      <span style={style.label}>
        <i style={style.label_name}>{label}</i>
        <b style={style.label_value}>{getDurationKr(childProps.value)}</b>
      </span>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Handle {...childProps} dragging={childProps.dragging.toString()} />
    </>
  );

  const onAfterChanged = (value: number) => {
    setValue(value);
  };

  return (
    <div
      className={cx('DurationFilter')}
      data-event-nlog="click"
      data-event-area-code={clickCode}
    >
      <Slider
        min={min}
        max={max}
        value={position}
        step={1}
        onChange={value => setPosition(value)}
        onAfterChange={onAfterChanged}
        marks={marks}
        handle={handle}
        trackStyle={style.track}
        railStyle={style.rail}
        handleStyle={style.handle}
        dotStyle={style.dot}
        style={style.slider}
      />
    </div>
  );
}

export default DurationFilter;
